
import { useEffect } from "react";
import AboutHero from "./component/AboutHero";
import Benefits from "./component/Benefits";
// import BestExperts from "./component/BestExperts";
import Immigration from "./component/Immigration";
import OnlineVisa from "./component/OnlineVisa";
import Traditional from "./component/Traditional";
import Unparalleled from "./component/Unparalleled";

export default function AaboutUs() {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);

    return (
        <>


            <AboutHero />
            <Traditional />
            <Unparalleled />
            <OnlineVisa />
            <Benefits />
            {/* <BestExperts /> */}
            <Immigration />
        </>

    )
}